import {req, reqJson} from './axiosFun';

/**
 * 广告管理
 **/

// 获取列表
export const advertisementList = (params) => {
  var url = "/api/advertisement/list?1=1"
  if (params.description != null && params.description != '') {
    url += "&description=" + params.description;
  }
  return reqJson("get", url)
};

// 新增保存
export const advertisementSave = (params) => {
  return reqJson("post", "/api/advertisement/save", params)
};

//编辑保存
export const advertisementUpdate = (params) => {
  return reqJson("post", "/api/advertisement/update", params)
};

//删除
export const advertisementDelete = (params) => {
  return reqJson("post", "/api/advertisement/delete/" + params.id)
};



// WEBPACK FOOTER //
// ./src/api/advertisementMG.js